import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Download, ArrowRight, Linkedin, Github, Gitlab } from 'lucide-react';
import './Home.css';

const Home = () => {
  const { t, isFrench } = useLanguage();

  const metrics = isFrench ? [
    { value: '5+', label: 'Projets livrés' },
    { value: 'CTO', label: 'TheGift SAS' },
    { value: 'iOS / Android', label: 'App Store & Google Play' },
    { value: '3iL', label: 'Master Manager Digital' },
  ] : [
    { value: '5+', label: 'Projects shipped' },
    { value: 'CTO', label: 'TheGift SAS' },
    { value: 'iOS / Android', label: 'App Store & Google Play' },
    { value: '3iL', label: 'Master\'s in Digital' },
  ];

  return (
    <section className="home" id="home">
      <div className="home-layout">
        <div className="home-inner">
          <p className="home-eyebrow">
            {isFrench ? 'Co-fondatrice & CTO · Limoges, France' : 'Co-founder & CTO · Limoges, France'}
          </p>

          <h1 className="home-title">Jason Kamsu</h1>

          <p className="home-role">
            {isFrench
              ? 'Développeuse full-stack — architecture mobile, backend et produit'
              : 'Full-stack engineer — mobile architecture, backend and product'}
          </p>

          <p className="home-summary">
            {isFrench
              ? 'Je conçois et déploie des produits mobiles et web de bout en bout. Co-fondatrice de TheGift SAS (Kotlin Multiplatform, Firebase), contributrice sur JunaPay et MadBeauty. Focus : architecture propre, livraison en production, CI/CD.'
              : 'I design and ship end-to-end mobile and web products. Co-founder of TheGift SAS (Kotlin Multiplatform, Firebase), contributor on JunaPay and MadBeauty. Focus: clean architecture, production delivery, CI/CD.'}
          </p>

          <div className="home-metrics">
            {metrics.map((item) => (
              <div key={item.label} className="home-metric">
                <span className="home-metric-value">{item.value}</span>
                <span className="home-metric-label">{item.label}</span>
              </div>
            ))}
          </div>

          <div className="home-actions">
            <Link to="/experience" className="btn primary">
              <span>{isFrench ? 'Voir les expériences' : 'View experience'}</span>
              <ArrowRight size={16} />
            </Link>
            <a href="/assets/CV_Jason_Kamsu.pdf" className="btn secondary" download>
              <Download size={16} />
              <span>{t('downloadCV')}</span>
            </a>
            <Link to="/contact" className="btn secondary">
              <span>{t('contactMe')}</span>
            </Link>
          </div>

          <div className="home-social">
            <a href="https://www.linkedin.com/in/jason-kamsu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={18} />
              <span>LinkedIn</span>
            </a>
            <a href="https://github.com/JayKamsu" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <Github size={18} />
              <span>GitHub</span>
            </a>
            <a href="https://gitlab.com/JasonKamsu" target="_blank" rel="noopener noreferrer" aria-label="GitLab">
              <Gitlab size={18} />
              <span>GitLab</span>
            </a>
          </div>
        </div>

        <div className="home-photo">
          <div className="home-photo-frame">
            <img src="/assets/Photo_VISA.png" alt="Jason Kamsu" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
